import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';

@Component({
  selector: 'app-placement-listening',
  templateUrl: './placement-listening.component.html',
  styleUrls: ['./placement-listening.component.scss']
})
export class PlacementListeningComponent implements OnInit {
  tabs = TESTING_CENTER.PLACEMENT_TEST;
  TESTING_TYPE_KEY: any;
  SKILL_KEY='listening';
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: PlacementTest,
    public ps: PrintService,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.TESTING_TYPE_KEY = param.id
      this.store.fetchData(COLLECTION_NAME.LISTENING, this.TESTING_TYPE_KEY)
    })
  }

  create() {
    this.router.navigate([`/testing-center/placement-test/${this.SKILL_KEY}/${this.TESTING_TYPE_KEY}/draft`])
  }
  
  edit(item:any) {
    this.router.navigate([`/testing-center/placement-test/${this.SKILL_KEY}/${this.TESTING_TYPE_KEY}/${item.key}`])
  }
}
